<template>
  <div class="expertTeam">
    <childLogo></childLogo>
    <div class="navbar-dark">
      <div class="container">
        <div class="sigma-content">
          <div class="sigma-middle-line">
            <span class="sigma-line-text">专家团队</span>
          </div>
        </div>
        <div style="font-size: 21px;margin: 15px;color: #5e5e5e;">{{siteName}}</div>
        <el-tabs class="selectExpert" type="card" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="院士专家" name="first">
            <el-row v-for="item in academicianExpert" :key="item.id">
              <el-col :span="4">
                <img :src="item.coverUrl" width="180px" height="240px" style="border-radius: 5px;" />
              </el-col>
              <el-col :span="20">
                <div class="expertName">{{item.title}}</div>
                <div
                  style="display: inline-block;text-align: right;width:49%;padding-right:20px;color:#818181"
                >{{item.subTitle}}</div>
                <div class="introduction" v-html="item.brief"></div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="顾问专家" name="second">
            <el-row v-for="item in consultantExpert" :key="item.id">
              <el-col :span="4">
                <img :src="item.coverUrl" width="180px" height="240px" style="border-radius: 5px;" />
              </el-col>
              <el-col :span="20">
                <div class="expertName">{{item.title}}</div>
                <div
                  style="display: inline-block;text-align: right;width:49%;padding-right:20px;color:#818181"
                >{{item.subTitle}}</div>
                <div class="introduction" v-html="item.brief"></div>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import ChildLogo from "@/components/ChildLogo.vue";

export default {
  components: {
    ChildLogo: ChildLogo
  },
  data() {
    return {
      siteName:"",
      activeName: "first",
      academicianExpert: [],
      consultantExpert: []
    };
  },
  created() {
    siteMess(this.siteURL,this.siteId).then(res=>{
      this.siteName = res.data.name;
    })
    this.getList();
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    getList() {
      //院士专家
    //  var api = this.siteURL + "/actuator/article/list?channelId=122";
      var api = this.siteURL + "/actuator/article/selectArticleList?siteId="+this.siteId+"&nameEn=AcademicianExpert";
      this.axios.get(api, {}).then(response => {
        this.academicianExpert = response.data.rows;
      });
      //顾问专家
     // var api = this.siteURL + "/actuator/article/list?channelId=123";
      var api = this.siteURL + "/actuator/article/selectArticleList?siteId="+this.siteId+"&nameEn=ConsultantExpert";
      this.axios.get(api, {}).then(response => {
        this.consultantExpert = response.data.rows;
      });
    }
  }
};
</script>

<style scoped>
.expertName {
  display: inline-block;
  text-align: left;
  width: 50%;
  color: #0c70fc;
  font-size: 36px;
  padding-left: 20px;
}

.introduction {
  text-align: left;
  padding: 20px;
  text-indent: 2em;
}

.sigma-content {
  margin: 40px 0 10px;
  text-align: center;
  background-color: #fff;
}
.sigma-middle-line:before {
  content: "";
  display: block;
  height: 1px;
  width: 100%;
  background-color: #0c70fc; /*颜色需与bai主题大背景du色一致zhi*/
  position: relative;
  top: 25px; /*调节线高*/
  left: 0;
}
.sigma-line-text {
  display: inline-block;
  background: #fff;
  padding: 0 18px 0 18px;
  position: relative;
  font-size: 28px;
  font-weight: 500;
  color: #0c70fc;
}
</style>

<style >
.expertTeam .el-tabs__item.is-active {
  color: #ffffff !important;
  background: #0c70fc;
}

.expertTeam .el-tabs--card > .el-tabs__header {
  border-bottom: none;
}

.expertTeam .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
  text-align: center;
  width: 100%;
}

.expertTeam .el-tabs--card > .el-tabs__header .el-tabs__item {
  border: 1px solid #0c70fc;
  width: 180px;
  border-radius: 6px;
  height: 45px;
  line-height: 45px;
  color: #0c70fc;
}

.expertTeam
  .el-tabs--top.el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item:last-child,
.expertTeam
  .el-tabs--top.el-tabs--card
  > .el-tabs__header
  .el-tabs__item:last-child {
  margin-left: 80px;
}
</style>



// WEBPACK FOOTER //
// src/views/ExpertTeam.vue